import { SUN_ZONE_ORDER, SUN_ZONES, zoneColor } from '../../scene3d/shadow/shadowZones';

/**
 * HeatmapLegend - Legende der Jahresübersicht (#606)
 *
 * Benennt die drei Lichtzonen und den Bezugszeitraum. Ruhig formuliert, ohne
 * Ampel-Semantik — Schatten ist eine Standortangabe, kein Fehler.
 */
const HeatmapLegend = () => (
  <div className="mt-2">
    <ul className="space-y-1">
      {SUN_ZONE_ORDER.map((key) => {
        const zone = SUN_ZONES[key];
        return (
          <li key={key} className="flex items-center gap-2 text-xs text-gray-600">
            <span
              className="inline-block h-3 w-3 flex-shrink-0 rounded-sm border border-black/10"
              style={{ backgroundColor: zoneColor(key) }}
              aria-hidden="true"
            />
            <span className="font-medium text-gray-700">{zone.label}</span>
            <span className="text-gray-400">{zone.hint}</span>
          </li>
        );
      })}
    </ul>
    <p className="mt-2 text-xs leading-relaxed text-gray-400">
      Mittlere direkte Sonne über die Vegetationsperiode (März–Oktober), ohne
      Nachbarbebauung außerhalb des Plans.
    </p>
  </div>
);

export default HeatmapLegend;
